import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "../lib/api";
import { SmokeParticles } from "./SmokeParticles";
import { useT } from "../i18n/LanguageContext";

const reveal = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({
    opacity: 1, y: 0,
    transition: { delay: i * 0.12, duration: 1, ease: [0.22, 0.61, 0.36, 1] }
  }),
};

export const IntroSection = () => {
  const { t } = useT();
  const x = t.intro;
  return (
    <section
      id="cose-il-gourmet-naif"
      className="relative section-pad section-pad-bottom-tight overflow-hidden"
      data-testid="intro-section"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <SmokeParticles count={3} />

      <div className="relative max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <motion.span
            variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
            custom={0} className="eyebrow"
          >
            {x.eyebrow}
          </motion.span>
          <motion.h2
            variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
            custom={1}
            className="mt-5 font-display font-light text-[36px] sm:text-[48px] md:text-[64px] lg:text-[74px] leading-[1.05] tracking-[-0.012em] text-[var(--pn-milk)]"
          >
            {x.title_a}{" "}
            <em className="italic text-[var(--pn-amber)]">{x.title_b}</em>{x.title_c}
          </motion.h2>
          <motion.div
            variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
            custom={2} className="mt-10 max-w-[620px] space-y-6"
          >
            <p className="text-[19px] md:text-[23px] leading-[1.65] text-[var(--pn-milk)] font-light">
              {x.p1_a}
              <span className="italic font-display text-[var(--pn-amber)]">{x.p1_b}</span>
              {x.p1_c}
            </p>
            <p className="text-[18px] md:text-[21px] leading-[1.7] text-[var(--pn-cream)]/90 font-light">
              {x.p2}
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 1.04 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.4, ease: [0.22, 0.61, 0.36, 1] }}
          className="lg:col-span-5 order-1 lg:order-2 relative"
        >
          <div className="frame aspect-[3/4] relative">
            <img src={ASSETS.picanhaSmoke} alt="" className="w-full h-full object-cover kenburns" />
          </div>
          <div className="absolute -bottom-6 -left-6 hidden md:block">
            <p className="font-display italic text-[var(--pn-amber)]/70 text-sm tracking-wider">
              {x.quote}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
